import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const ServiceSelectionSection = ({ formData, handleInputChange, handleServiceChange, errors }) => {
  const primaryServices = [
    { value: '', label: 'Select Primary Service', disabled: true },
    { value: 'web-development', label: 'Web Development & Design' },
    { value: 'mobile-development', label: 'Mobile App Development' },
    { value: 'cloud-services', label: 'Cloud Infrastructure & DevOps' },
    { value: 'cybersecurity', label: 'Cybersecurity Solutions' },
    { value: 'data-analytics', label: 'Data Analytics & AI' },
    { value: 'it-consulting', label: 'IT Consulting & Strategy' },
    { value: 'managed-services', label: 'Managed IT Services' },
    { value: 'digital-transformation', label: 'Digital Transformation' },
    { value: 'Other Services', label: 'Other Services' }
  ];

  const additionalServices = [
    { id: 'ui-ux-design', label: 'UI/UX Design & Prototyping' },
    { id: 'api-integration', label: 'API Development & Integration' },
    { id: 'database-optimization', label: 'Database Design & Optimization' },
    { id: 'performance-optimization', label: 'Performance Optimization' },
    { id: 'security-audit', label: 'Security Audit & Compliance' },
    { id: 'staff-augmentation', label: 'Staff Augmentation' },
    { id: 'training-support', label: 'Training & Technical Support' },
    { id: 'maintenance', label: 'Ongoing Maintenance & Updates' }
  ];

  return (
    <div className="space-y-6">
      <div className="border-b border-border pb-4">
        <h3 className="text-xl font-semibold text-foreground mb-2">Service Selection</h3>
        <p className="text-text-secondary text-sm">
          Choose your primary service and any additional services you need
        </p>
      </div>
      <Select
        label="Primary Service Required"
        options={primaryServices}
        value={formData?.primaryService}
        onChange={(value) => handleInputChange({ target: { name: 'primaryService', value } })}
        error={errors?.primaryService}
        required
        description="Select the main service you need for your project"
        className="mb-6"
      />
      <div className="space-y-4">
        <label className="block text-sm font-medium text-foreground">
          Additional Services (Optional)
        </label>
        <p className="text-xs text-text-secondary mb-4">
          Select any additional services that complement your primary requirement
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {additionalServices?.map((service) => (
            <Checkbox
              key={service?.id}
              label={service?.label}
              checked={formData?.additionalServices?.includes(service?.id)}
              onChange={(e) => handleServiceChange(service?.id, e?.target?.checked)}
              className="text-sm"
            />
          ))}
        </div>
      </div>
      {formData?.primaryService && (
        <div className="mt-6 p-4 bg-accent/10 border border-accent/20 rounded-lg">
          <h4 className="font-medium text-accent mb-2">Service Details</h4>
          <p className="text-sm text-text-secondary">
            {formData?.primaryService === 'web-development' && 
              "Full-stack web development including frontend, backend, and database design with modern frameworks and responsive design."}
            {formData?.primaryService === 'mobile-development' && 
              "Native and cross-platform mobile app development for iOS and Android with modern UI/UX and backend integration."}
            {formData?.primaryService === 'cloud-services' && 
              "Cloud infrastructure setup, migration, containerization, CI/CD pipelines, and DevOps automation solutions."}
            {formData?.primaryService === 'cybersecurity' && 
              "Comprehensive security solutions including penetration testing, compliance audits, and security infrastructure setup."}
            {formData?.primaryService === 'data-analytics' && 
              "Data pipeline development, business intelligence, machine learning models, and AI-powered analytics solutions."}
            {formData?.primaryService === 'it-consulting' && 
              "Strategic IT planning, technology assessment, digital roadmap development, and technical architecture consulting."}
            {formData?.primaryService === 'managed-services' && 
              "24/7 IT support, system monitoring, maintenance, backup solutions, and proactive infrastructure management."}
            {formData?.primaryService === 'digital-transformation' && 
              "End-to-end digital transformation including process automation, system modernization, and technology adoption."}
          </p>
        </div>
      )}
    </div>
  );
};

export default ServiceSelectionSection;